import React from "react";

const AmountComma = ({ row }) => {
  return (
    <div>
      {row?.amount?.toLocaleString() ? row?.amount?.toLocaleString() : "-"}
    </div>
  );
};

export default AmountComma;
